import { useCallback, useRef, useState } from 'react';
import ISwiper from 'swiper';

export const useVfSwiper = () => {
  const [swiper, setSwiper] = useState<ISwiper | null>(null);

  const navigationPrevRef = useRef<HTMLButtonElement | null>(null);
  const navigationNextRef = useRef<HTMLButtonElement | null>(null);

  const onSwiper = useCallback((s: ISwiper) => {
    setSwiper(s);
  }, []);

  const slidePrev = useCallback(() => {
    swiper?.slidePrev();
  }, [swiper]);

  const slideNext = useCallback(() => {
    swiper?.slideNext();
  }, [swiper]);

  return {
    navigationPrevRef,
    navigationNextRef,
    onSwiper,
    slidePrev,
    slideNext,
  };
};

